/* [BD feat] Global theme scripts: cart drawer bubble sync + predictive search featured row Swipers.
 * Section-specific behavior lives in bd-section-*.js files loaded by each section.
 */

;(function () {
  var bdSearchSwiperWaitMs = 50;
  var bdSearchSwiperWaitMax = 120;

  function waitForSwiperForSearch(cb, left) {
    if (typeof window.Swiper === 'function') {
      cb();
      return;
    }
    left = typeof left === 'number' ? left : bdSearchSwiperWaitMax;
    if (left <= 0) return;
    setTimeout(function () {
      waitForSwiperForSearch(cb, left - 1);
    }, bdSearchSwiperWaitMs);
  }

  var bdSearchFeaturedDesktopBp = 990;

  function readBdSfcRowDataNum(node, name, fallback, min, max) {
    var raw = node.getAttribute(name);
    var v = parseFloat(raw);
    if (isNaN(v)) v = fallback;
    if (typeof min === 'number' && v < min) v = min;
    if (typeof max === 'number' && v > max) v = max;
    return v;
  }

  function destroyBdSfcRowSwiper(el) {
    if (!el) return;
    var sw = el._bdSfcRowSwiper;
    if (sw && typeof sw.destroy === 'function') {
      try {
        sw.destroy(true, true);
      } catch (e) {}
      el._bdSfcRowSwiper = null;
    }
  }

  function getBdSfcRowConfigEl(swiperEl) {
    if (
      swiperEl &&
      swiperEl.hasAttribute &&
      swiperEl.hasAttribute('data-bd-search-predictive-products-swiper')
    ) {
      var host = swiperEl.closest && swiperEl.closest('predictive-search');
      if (host) return host;
    }
    return swiperEl;
  }

  function initBdSfcRowSwiper(el) {
    if (!el) return;
    var slideCount = el.querySelectorAll('.swiper-slide').length;
    if (!slideCount) return;

    waitForSwiperForSearch(function () {
      if (typeof window.Swiper !== 'function') return;
      if (el._bdSfcRowSwiper) {
        try {
          el._bdSfcRowSwiper.update();
        } catch (e2) {}
        return;
      }

      var cfg = getBdSfcRowConfigEl(el);
      var spvMobile = readBdSfcRowDataNum(cfg, 'data-bd-sfc-spv-mobile', 1.5, 0.5, 6);
      var spvDesktop = readBdSfcRowDataNum(cfg, 'data-bd-sfc-spv-desktop', 2.5, 0.5, 6);
      var gapMobile = readBdSfcRowDataNum(cfg, 'data-bd-sfc-gap-mobile', 15, 0, 80);
      var gapDesktop = readBdSfcRowDataNum(cfg, 'data-bd-sfc-gap-desktop', 24, 0, 80);

      spvMobile = Math.min(spvMobile, slideCount);
      spvDesktop = Math.min(spvDesktop, slideCount);

      var reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var breakpoints = {};
      breakpoints[bdSearchFeaturedDesktopBp] = {
        slidesPerView: spvDesktop,
        spaceBetween: gapDesktop,
      };

      try {
        el._bdSfcRowSwiper = new window.Swiper(el, {
          slidesPerView: spvMobile,
          spaceBetween: gapMobile,
          breakpoints: breakpoints,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          watchSlidesProgress: true,
          speed: reduceMotion ? 0 : 320,
          threshold: 6,
          resistanceRatio: 0.88,
          mousewheel: {
            enabled: !reduceMotion,
            forceToAxis: true,
            releaseOnEdges: true,
            sensitivity: 1,
          },
        });
      } catch (err) {
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('[bd-sfc-row] Swiper init failed', err);
        }
      }
    });
  }

  function initBdSearchFeaturedSwiper(detailsEl) {
    var scope = detailsEl && detailsEl.querySelector ? detailsEl : document;
    var el = scope.querySelector('[data-bd-search-featured-swiper]');
    if (el) initBdSfcRowSwiper(el);
  }

  /** Called from predictive-search.js after AJAX results (header drawer + search template). */
  window.bdInitSearchPredictiveProductsSwipers = function (root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-bd-search-predictive-products-swiper]').forEach(initBdSfcRowSwiper);
  };

  var bdSearchFeaturedToggleBound = false;
  function bindBdSearchFeaturedToggle() {
    if (bdSearchFeaturedToggleBound) return;
    bdSearchFeaturedToggleBound = true;
    document.addEventListener(
      'toggle',
      function (ev) {
        var d = ev.target;
        if (!d || d.tagName !== 'DETAILS') return;
        if (
          !d.closest ||
          (!d.closest('details-modal.header__search') && !d.closest('header-drawer.bd-header-nav-drawer'))
        ) {
          return;
        }
        if (!d.open) return;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            initBdSearchFeaturedSwiper(d);
          });
        });
      },
      true
    );
  }

  function initBdSearchFeaturedInDocument(scope) {
    bindBdSearchFeaturedToggle();
    var root = scope && scope.querySelector ? scope : document;
    if (!root.querySelector) return;
    var detSearch = root.querySelector('details-modal.header__search details[open]');
    if (detSearch && detSearch.open) initBdSearchFeaturedSwiper(detSearch);
    var detNav = root.querySelector('header-drawer.bd-header-nav-drawer details[open]');
    if (detNav && detNav.open) initBdSearchFeaturedSwiper(detNav);
  }

  function destroyBdSearchFeaturedInScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope
      .querySelectorAll('[data-bd-search-featured-swiper], [data-bd-search-predictive-products-swiper]')
      .forEach(destroyBdSfcRowSwiper);
  }

  function syncBdNavDrawerCartFromHeader() {
    var source = document.getElementById('cart-icon-bubble');
    var target = document.querySelector('a[data-bd-cart-drawer-trigger]');
    if (!source || !target) return;
    target.innerHTML = source.innerHTML;
  }

  function initBdNavDrawerCartBubbleSync() {
    syncBdNavDrawerCartFromHeader();
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(syncBdNavDrawerCartFromHeader, 0);
    });
  }

  function onReady() {
    initBdNavDrawerCartBubbleSync();
    initBdSearchFeaturedInDocument(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      if (event.target.querySelector && event.target.querySelector('#cart-icon-bubble')) {
        syncBdNavDrawerCartFromHeader();
      }
      destroyBdSearchFeaturedInScope(event.target);
      initBdSearchFeaturedInDocument(event.target);
    });

    document.addEventListener('shopify:section:select', function (event) {
      if (!event || !event.target) return;
      destroyBdSearchFeaturedInScope(event.target);
      initBdSearchFeaturedInDocument(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event || !event.target || !event.target.querySelector) return;
      destroyBdSearchFeaturedInScope(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { html, sectionId } = event.data;

    const currentSection = document.getElementById(`MainProduct-${sectionId}`) || document;
    const currentMetafield = currentSection.querySelector('.variant_metafield');

    const newMetafield = html.querySelector('.variant_metafield');

    if (currentMetafield && newMetafield) {
      currentMetafield.innerHTML = newMetafield.innerHTML;
    }
  });  
})();
